(function () {
  // Standalone asset: theme.min.js is prebuilt and can't be edited here.
  // Keep // comments short, see CUSTOM_IMPLEMENTATIONS.md (Shopify asset limit).
  var SELECTOR = "[data-product-pairing-slider]";
  var MOBILE_MAX_SLIDES_PER_VIEW = 2;
  var SPACE_BETWEEN_MOBILE = 16;
  var SPACE_BETWEEN_DESKTOP = 18;

  function initSlider(root) {
    if (root.dataset.productPairingSliderInit === "true") {
      return;
    }

    var carousel = root.querySelector(".product-pairing-slider__carousel");
    if (!carousel) {
      return;
    }

    if (!window.flu || !window.flu.chunks || !window.flu.chunks.swiper) {
      return;
    }

    var slidesPerView = parseFloat(carousel.dataset.slidesPerView) || 2;
    var nextButton = root.querySelector("[data-next]");
    var prevButton = root.querySelector("[data-prev]");

    root.dataset.productPairingSliderInit = "true";

    import(new URL(window.flu.chunks.swiper, window.location.href).href).then(function (mod) {
      // Max 2 on phones: the 48px quick-add button crowds the image.
      var options = {
        slidesPerView: Math.min(slidesPerView, MOBILE_MAX_SLIDES_PER_VIEW),
        spaceBetween: SPACE_BETWEEN_MOBILE,
        grabCursor: true,
        watchSlidesProgress: true,
        breakpoints: {
          720: { slidesPerView: slidesPerView, spaceBetween: SPACE_BETWEEN_DESKTOP },
        },
      };

      if (nextButton && prevButton) {
        options.modules = [mod.Navigation];
        options.navigation = {
          nextEl: nextButton,
          prevEl: prevButton,
        };
      }

      new mod.Swiper(carousel, options);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(initSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-init on theme editor block/section re-renders.
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
